import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.46295 8.5H2.33301V21.6701H6.46295V8.5Z" }, null, -1),
    _createElementVNode("path", { d: "M17.6351 8.21465C17.4829 8.19562 17.3211 8.18611 17.1593 8.17659C14.8469 8.08143 13.5433 9.45173 13.0865 10.0417C12.9628 10.2035 12.9057 10.2987 12.9057 10.2987V8.5382H8.95654V21.7083H12.9057H13.0865C13.0865 20.3666 13.0865 19.0343 13.0865 17.6926C13.0865 16.9694 13.0865 16.2462 13.0865 15.5229C13.0865 14.6284 13.0199 13.6768 13.4671 12.8585C13.8478 12.1733 14.5329 11.8307 15.3037 11.8307C17.5875 11.8307 17.6351 13.8957 17.6351 14.086C17.6351 14.0955 17.6351 14.1051 17.6351 14.1051V21.7654H21.7651V13.1725C21.7651 10.232 20.2711 8.50013 17.6351 8.21465Z" }, null, -1),
    _createElementVNode("path", { d: "M4.39803 6.79606C5.72242 6.79606 6.79606 5.72243 6.79606 4.39803C6.79606 3.07363 5.72242 2 4.39803 2C3.07363 2 2 3.07363 2 4.39803C2 5.72243 3.07363 6.79606 4.39803 6.79606Z" }, null, -1)
  ])))
}
export default { render: render }